import { render, staticRenderFns } from "./CarouselSpotlight.vue?vue&type=template&id=b71b4238&scoped=true&"
import script from "./CarouselSpotlight.vue?vue&type=script&lang=js&"
export * from "./CarouselSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSpotlight.vue?vue&type=style&index=0&id=b71b4238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71b4238",
  null
  
)

export default component.exports